import * as type from "../../types/API/production";

export function startProduction(payload: any) {
  return {
    type: type.START_PRODUCTION,
    payload: payload,
  };
}

export function getProductions(payload: any) {
  return {
    type: type.GET_PRODUCTION,
    payload: payload,
  };
}

export function getBulkProductions(payload: any) {
  return {
    type: type.GET_BULK_PRODUCTION,
    payload: payload,
  };
}

export function getProductionById(payload: any) {
  return {
    type: type.GET_PRODUCTION_BY_ID,
    payload: payload,
  };
}

export function updateProcess(payload: any) {
  return {
    type: type.UPDATE_PROCESS,
    payload: payload,
  };
}

export function updateCost(payload: any) {
  return {
    type: type.UPDATE_COST,
    payload: payload,
  };
}

export function saveFinishedGoods(payload: any) {
  return {
    type: type.SAVE_FINISHED_GOODS,
    payload: payload,
  };
}

export function saveRework(payload: any) {
  return {
    type: type.SAVE_REWORK,
    payload: payload,
  };
}

export function updateProductionStatus(payload: any) {
  return {
    type: type.UPDATE_PRODUCTION_STATUS,
    payload: payload,
  };
}

export function updateScrapLogsStatus(payload: any) {
  return {
    type: type.UPDATE_SCRAP_LOGS,
    payload: payload,
  };
}

export function saveProduction(payload: any) {
  return {
    type: type.SAVE_PRODUCTION,
    payload: payload,
  };
}

export function materialPlanning(payload: any) {
  return {
    type: type.MATERIAL_PLANNING,
    payload: payload,
  };
}

export function minStockMaterialPlanning(payload: any) {
  return {
    type: type.MIN_STOCK_MATERIAL_PLANNING,
    payload: payload,
  };
}

export function bomBasedMaterialPlanning(payload: any) {
  return {
    type: type.BOM_BASED_MATERIAL_PLANNING,
    payload: payload,
  };
}

export function getProductionsByCompanyId(payload: any) {
  return {
    type: type.GET_PRODUCTIONS_BY_COMPANY_ID,
    payload: payload,
  };
}

export function productionBasedMaterialPlanning(payload: any) {
  return {
    type: type.PRODUCTION_BASED_MATERIAL_PLANNING,
    payload: payload,
  };
}

export function updateTableData(payload: any) {
  return {
    type: type.UPDATE_TABLE,
    payload: payload,
  };
}

export function removeRows(payload: any) {
  return {
    type: type.REMOVE_ROWS,
    payload: payload,
  };
}

export function viewProductionHistory(payload: any) {
  return {
    type: type.VIEW_PRODUCTION_HISTORY,
    payload: payload,
  };
}

export function returnRawMaterial(payload: any) {
  return {
    type: type.RETURN_RAW_MATERIAL,
    payload: payload,
  };
}

export function startBulkProduction(payload: any) {
  return {
    type: type.START_BULK_PRODUCTION,
    payload: payload,
  };
}

export function getBulkProduction(payload: any) {
  return {
    type: type.GET_BULK_PRODUCTIONS,
    payload: payload,
  };
}

export function getRemainingProduction(payload: any) {
  return {
    type: type.GET_REMAINING_PRODUCTION,
    payload: payload,
  };
}

export function discardProduction(payload: any) {
  return {
    type: type.DISCARD_PRODUCTION,
    payload: payload,
  };
}

export function bulkIssue(payload: any) {
  return {
    type: type.BULK_ISSUE,
    payload: payload,
  };
}

export function updateStartDate(payload: any) {
  return {
    type: type.UPDATE_START_DATE,
    payload: payload,
  };
}

export function getAllProductions(payload: any) {
  return {
    type: type.GET_ALL_PRODUCTIONS,
    payload: payload,
  };
}

export function deleteLogs(payload: any) {
  return {
    type: type.DELETE_LOGS,
    payload: payload,
  };
}